import { MinusCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMinusCircle12Line = createIcon(MinusCircle, 12, "Line");
export const IconMinusCircle16Line = createIcon(MinusCircle, 16, "Line");
export const IconMinusCircle20Line = createIcon(MinusCircle, 20, "Line");
export const IconMinusCircle24Line = createIcon(MinusCircle, 24, "Line");
export const IconMinusCircle32Line = createIcon(MinusCircle, 32, "Line");
export const IconMinusCircle48Line = createIcon(MinusCircle, 48, "Line");
export const IconMinusCircle64Line = createIcon(MinusCircle, 64, "Line");
